var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { validateSchema } from '../config-schema/index';
/**
 *
 * @param {Promise<unknown>} method - Any async method that needs to be retried a certain number of times.
 * @param @optional {number} retries
 * @returns {Promise<ImportWithRetryResponse>}
 */
export var asyncWithRetries = function (method, retries) {
    if (retries === void 0) { retries = 3; }
    return __awaiter(void 0, void 0, void 0, function () {
        var result, error_1, updatedRetries;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, method()];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, {
                            status: true,
                            result: result,
                        }];
                case 2:
                    error_1 = _a.sent();
                    updatedRetries = retries - 1;
                    if (updatedRetries >= 0) {
                        return [2 /*return*/, asyncWithRetries(method, updatedRetries)];
                    }
                    return [2 /*return*/, {
                            status: false,
                            error: error_1,
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
};
/**
 * Uses the validate method from ajv.
 * @param {unknown} config
 * @returns {boolean}
 */
export var validateConfigSchema = function (config) {
    return validateSchema(config);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXRpbHMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvdXRpbHMvdXRpbHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLGNBQWMsRUFBRSxNQUFNLHdCQUF3QixDQUFDO0FBUXhEOzs7OztHQUtHO0FBQ0gsTUFBTSxDQUFDLElBQU0sZ0JBQWdCLEdBQUcsVUFBTyxNQUE4QixFQUFFLE9BQVc7SUFBWCx3QkFBQSxFQUFBLFdBQVc7Ozs7Ozs7b0JBRS9ELHFCQUFNLE1BQU0sRUFBRSxFQUFBOztvQkFBdkIsTUFBTSxHQUFHLFNBQWM7b0JBRTdCLHNCQUFPOzRCQUNMLE1BQU0sRUFBRSxJQUFJOzRCQUNaLE1BQU0sUUFBQTt5QkFDUCxFQUFDOzs7b0JBRUksY0FBYyxHQUFHLE9BQU8sR0FBRyxDQUFDLENBQUM7b0JBQ25DLElBQUksY0FBYyxJQUFJLENBQUMsRUFBRTt3QkFDdkIsc0JBQU8sZ0JBQWdCLENBQUMsTUFBTSxFQUFFLGNBQWMsQ0FBQyxFQUFDO3FCQUNqRDtvQkFFRCxzQkFBTzs0QkFDTCxNQUFNLEVBQUUsS0FBSzs0QkFDYixLQUFLLFNBQUE7eUJBQ04sRUFBQzs7Ozs7Q0FFTCxDQUFDO0FBRUY7Ozs7R0FJRztBQUNILE1BQU0sQ0FBQyxJQUFNLG9CQUFvQixHQUFHLFVBQUMsTUFBZTtJQUNsRCxPQUFPLGNBQWMsQ0FBQyxNQUFNLENBQVksQ0FBQztBQUMzQyxDQUFDLENBQUMifQ==